/** @jsxImportSource @emotion/react */
import { DATADOG_ACTIONS } from '@app/app-constants'
import { toast } from '@app/components/ui/Toast/toast'
import apiClient from '@app/config/axios.config'
import { userAtom } from '@app/hooks/useUserProfile'
import { drawAreasAtom, regionMasksAtom } from '@app/risk-migration/atoms/riskFilters.atoms'
import { useRiskLayersState } from '@app/risk-migration/hooks/useRiskLayersState'
import { clientNameAtom } from '@app/state/clientsAtom'
import { logDataDogAction } from '@app/utils/logger'
import { pollForReport } from '@app/utils/pollForReport'
import { MenuItem, useTheme } from '@mui/material'
import { Polygon, Position } from 'geojson'
import { useAtomValue } from 'jotai'
import { RegionOption } from '../../RegionFilter'
import { exportButton } from './ExportRiskSummaryXlxs.styles'
export const ExportRiskSummaryGeoJsonButton = () => {
  const theme = useTheme()
  const drawAreas = useAtomValue(drawAreasAtom)
  const { layers } = useRiskLayersState()
  const clientName = useAtomValue(clientNameAtom)
  const regionMasks = useAtomValue(regionMasksAtom)

  const { data: user } = useAtomValue(userAtom)

  const handleClick = async () => {
    toast({
      description:
        'Generating data for report. This may take a while, we will notify you when the report is ready.',
      type: 'info',
    })

    logDataDogAction(DATADOG_ACTIONS.EXPORT_REPORT, {
      type: 'risk-summary',
      format: 'geojson',
    })

    const assetLayers = layers.filter((layer) => layer.layerType === 'asset')
    const hazardLayers = layers.filter((layer) => layer.layerType === 'hazard')
    const regions = regionMasks ? regionMasks.map((mask: RegionOption) => mask.region) : []
    const draw_area_coordinates: Position[][] | null =
      drawAreas.length > 0 ? (drawAreas[0].geometry as Polygon).coordinates : null

    const report_id = `${user?.user_uuid}-${Date.now()}`
    try {
      await apiClient.post(`/report/export/${clientName}/risksummary-geojson/${report_id}`, {
        asset_types: assetLayers.map((layer) => layer.type),
        hazard_scenarios: hazardLayers.map((layer) => layer.assetTag),
        regions,
        draw_area_coordinates,
      })

      pollForReport(report_id, 'UrbanIntelligenceRiskSummaryGeoJSONExport.zip')
    } catch (error) {
      toast({
        description:
          'There was an error generating the report. Please notify your Urban Intelligence contact or submit feedback.',
        type: 'error',
      })
    }
  }

  return (
    <MenuItem css={exportButton({ theme })} onClick={handleClick}>
      Spatial file (GeoJSON)
    </MenuItem>
  )
}
